export const bannerData = {
    about: {
        background: "images/banner/aboutus.jpg",
        title: "About Us",
        crumb: "About Us",
        watermark: "Infotrace Analytics"
    },
    faq: {
        background: "images/banner/faqs.jpg",
        title: "Faq Page",
        crumb: "Faq Page",
        watermark: "Infotrace Analytics"
    },
    gallery: {
        background: "images/banner/terms.jpg",
        title: "Gallery Page",
        crumb: "Gallery Page",
        watermark: "Infotrace Analytics"
    },
    icons: {
        background: "images/banner/bnr-4.jpg",
        title: "Icons",
        crumb: "icon-font",
        watermark: "Infotrace Analytics"
    },
    testimonials: {
        background: "images/banner/bnr-3.jpg",
        title: "Testimonials",
        crumb: "Testimonials",
        watermark: "Infotrace Analytics"
    },
    whychooseus: {
        background: "images/banner/bnr-8.jpg",
        title: "Why Choose us",
        crumb: "Why Choose us",
        watermark: "Infotrace Analytics"
    },
    pricing: {
        background: "images/banner/bnr-7.jpg",
        title: "Price Table",
        crumb: "Price Table",
        watermark: "Infotrace Analytics"
    },
    team: {
        background: "images/banner/bnr-2.jpg",
        title: "Team Member",
        crumb: "Team Member",
        watermark: "Infotrace Analytics"
    },
    mission: {
        background: "images/banner/bnr-7.jpg",
        title: "Mission & Vision",
        crumb: "Mission & Vision",
        watermark: "Infotrace Analytics"
    },
    services: {
        background: "images/banner/services.jpg",
        title: "Our Services",
        crumb: "Our Services",
        watermark: "Infotrace Analytics"
    },
    servicesdetails: {
        background: "images/banner/services.jpg",
        title: "Our Services Details",
        crumb: "Our Services Detail",
        watermark: "Infotrace Analytics"
    },
    portfolio1: {
        background: "images/banner/bnr-4.jpg",
        title: "Portfolio Page",
        crumb: "Portfolio",
        watermark: "Infotrace Analytics"
    },
    portfolio2: {
        background: "images/banner/bnr-5.jpg",
        title: "Portfolio-2 Page",
        crumb: "Portfolio-2 Page",
        watermark: "Infotrace Analytics"
    },
    portfoliodetail: {
        background: "images/banner/bnr-7.jpg",
        title: "Portfolio Detail",
        crumb: "Portfolio Detail",
        watermark: "Infotrace Analytics"
    },
    bloggrid: {
        background: "images/banner/blog.jpg",
        title: "Blog Page",
        crumb: "Blog Page",
        watermark: "Infotrace Analytics"
    },
    bloglistsidebar: {
        background: "images/banner/bnr-8.jpg",
        title: "Blog Archive",
        crumb: "Blog Single Grid",
        watermark: "Infotrace Analytics"
    },
    blogdetail: {
        background: "images/banner/blog.jpg",
        title: "Blog detail",
        crumb: "Blog detail",
        watermark: "Infotrace Analytics"
    },
    blogdetailsidebar: {
        background: "images/banner/bnr-10.jpg",
        title: "Blog detail",
        crumb: "Blog detail",
        watermark: "Infotrace Analytics"
    },
    careers: {
        background: "images/banner/blog.jpg",
        title: "Join Our Team",
        crumb: "Careers",
        watermark: "Infotrace Analytics"
    },
    contact: {
        background: "images/banner/contact.jpg",
        title: "Contact Us",
        crumb: "Contact Us",
        watermark: "Infotrace Analytics"
    },
    privacy: {
        background: "images/banner/terms.jpg",
        title: "Privacy Policy",
        crumb: "Privacy Policy",
        watermark: "Infotrace Analytics"
    }
}